import { Button, Stack, Typography } from '@mui/material';

import PageContainer from '../../../components/layout/PageContainer';

import type { TreatmentPlanVersionErrorProps } from '../types';

export default function TreatmentPlanVersionError({ onRetry }: TreatmentPlanVersionErrorProps) {
  return (
    <PageContainer sx={{ pt: 6 }}>
      <Stack alignItems="center" spacing={2}>
        <Typography>We could not load this treatment plan.</Typography>
        <Button onClick={onRetry} variant="contained">
          Try again
        </Button>
      </Stack>
    </PageContainer>
  );
}
